// @flow
import React from 'react';
// graphql
import { graphql, createFragmentContainer } from 'react-relay';
// list
import TopicsListItem from './TopicsListItem';

type Props = {
    viewer: Object
};

class TopicsList extends React.Component<Props> {
    renderList = topics => (
        topics.edges.map((topic) => {
            // if (topic.node.hidden) {
            //     return null;
            // }
            return (
                <TopicsListItem
                    key={topic.node.id}
                    topic={topic.node}
                />
            );
        })
    );

    render() {
        return <div className="topics--list">{this.renderList(this.props.viewer.topics)}</div>;
    }
}

export default createFragmentContainer(TopicsList, {
    viewer: graphql`
        fragment TopicsList_viewer on Viewer {
            topics(first: -1) {
                edges {
                    node {
                        id
                        hidden
                        ...TopicsListItem_topic
                    }
                }
            }
        }
    `,
});



// WEBPACK FOOTER //
// src/components/topics/TopicsList.js